import {errorPagesConfigs} from './errorPages';
import {authRouteConfig} from './auth';
import {initialUrl} from '../shared/constants/AppConst';
import {Redirect} from 'react-router-dom';
import Error403 from './errorPages/Error403';
import React from 'react';
import {FcHome} from 'react-icons/all';

const authorizedStructure = {
  fallbackPath: '/laju/ui',
  unAuthorizedComponent: <Error403 />,
  routes: [
    // ...profileConfig,
    // ...pendingTaskConfig,
    // ...profileConfig,
    // ...userGroupConfig,
    // ...dashboardConfig,
    // ...ecommerceConfig,
    // ...extraPagesConfigs,
    // ...componentsConfigs,
    // ...thirdPartyConfigs,
    // ...userPagesConfig,
    // ...appsConfig
    // ...menuLevelConfig,
    // ...userListConfig,
    // ...profileConfig,
    // ...userManagementConfig,
  ],
};

const unAuthorizedStructure = {
  fallbackPath: initialUrl,
  routes: authRouteConfig,
};

let menuList = {
  fallbackPath: '/laju/ui',
  unAuthorizedComponent: <Error403 />,
  routes: [],
};

const anonymousStructure = {
  routes: errorPagesConfigs.concat([
    {
      path: '/',
      exact: true,
      component: () => <Redirect to='/laju/ui' />,
    },
  ]),
};

const menuDefault = [
  {
    id: 'MNU_HOME',
    title: 'CRM',
    messageId: '',
    icon: <FcHome />,
    path: '/dashboards/crm',
  },
];

export {
  authorizedStructure,
  unAuthorizedStructure,
  anonymousStructure,
  menuList,
  menuDefault,
};
